import React from 'react'

export default function ProductTextSection ({
  tagline,
  title,
  description,
  fromPrice,
  permalink,
  buttonText
}) {
  return (
    <div className="mtt-iu-product__text-container">
      {tagline && (
        <p className="mtt-iu-product__tagline iu-tagline">{tagline}</p>
      )}
      {title && (
        <h2 className="mtt-iu-product__title">{title}</h2>
      )}
      {description && (
        <div className="mtt-iu-product__text" dangerouslySetInnerHTML={{ __html: description }} />
      )}
      {fromPrice && (
        <p className="mtt-iu-product__price">{fromPrice}</p>
      )}
      <div className="mtt-iu-product__button-container">
        <a href={permalink} className="mtt-iu-button" target={"_blank"} rel={"noreferrer"}>{buttonText}</a>
      </div>
    </div>
  )
}
